module.exports = __webpack_public_path__ + "img/fat-stalk.81cf484a.svg";